var _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchNotFound(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 0C71.4157 0 92 20.5856 92 45.9999C92 71.4152 71.4157 91.9998 46 91.9998C20.5852 91.9998 0 71.4152 0 45.9999C0 20.5856 20.5852 0 46 0Z",
    fill: "#798897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.1396 54.934C86.9693 76.0486 68.3067 91.9999 46.0009 91.9999C32.1021 91.9999 19.6591 85.8447 11.2539 76.1143L22.0429 65.3278C23.1682 64.2007 24.5573 63.8045 25.8808 64.0035C27.0069 62.8782 28.1312 61.7528 29.3213 60.6277C21.7125 51.0963 22.3728 37.1962 31.1095 28.3954C40.575 18.9307 55.9955 18.9307 65.4601 28.3954C74.129 37.0637 82.6687 45.9998 91.1396 54.934Z",
    fill: "#55606A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3048 74.2599L18.4004 70.2917L32.2335 56.4565L36.2054 60.3628L22.3048 74.2599Z",
    fill: "#37373E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69922 81.4763C2.91276 83.2638 2.91276 85.9772 4.69922 87.7637C6.42171 89.4835 9.201 89.4835 10.9225 87.7637L27.7329 70.953C29.5203 69.1647 29.5203 66.4511 27.7329 64.6638C25.9456 62.8783 23.2311 62.8783 21.4448 64.6638L4.69922 81.4763Z",
    fill: "#4B4B55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8637 27.7972C74.2615 37.1961 74.2615 52.6197 64.8637 62.0827C55.3989 71.5476 39.9786 71.5476 30.5138 62.0827C21.0501 52.6197 21.0501 37.1961 30.5138 27.7972C39.9786 18.3352 55.3989 18.3352 64.8637 27.7972ZM34.6832 57.9143C41.765 64.9963 53.3485 64.9963 60.5626 57.9143C67.6445 50.8315 67.6445 39.2484 60.5626 32.0341C53.4808 24.9521 41.8973 24.9521 34.6832 32.0341C27.6031 39.1161 27.6031 50.701 34.6832 57.9143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6831 57.9143C27.603 50.701 27.603 39.1162 34.6831 32.0342C41.8973 24.9522 53.4809 24.9522 60.5626 32.0342C67.6445 39.2485 67.6445 50.8315 60.5626 57.9143C53.3485 64.9964 41.765 64.9964 34.6831 57.9143Z",
    fill: "#798897"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.577 56.1267C65.129 49.6402 65.129 38.9844 58.577 32.3645C58.1131 31.9024 57.649 31.4394 57.1868 31.042C58.1129 31.7032 58.9723 32.4311 59.7669 33.2277C66.3199 39.8438 66.3199 50.4368 59.7669 56.9869C53.6796 63.0105 44.0149 63.4735 37.4629 58.2457C43.9484 62.5484 52.8175 61.8185 58.577 56.1267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.916 52.2035C42.5744 50.8458 44.9176 50.167 47.9993 50.167C50.8999 50.167 53.1968 51.0008 54.8364 52.2035",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.007 39.3335H53",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.007 39.3335H43",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchNotFound);
export default __webpack_public_path__ + "static/media/search-not-found.99a66f6c6f6b6de55aa9e2105d5cf50f.svg";
export { ForwardRef as ReactComponent };